const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle, style) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	if (style) newImage.style.cssText = style;
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (!wrapper.dataset.originalSrc && primaryImage) {
					wrapper.dataset.originalSrc = primaryImage.src;
					wrapper.dataset.originalSrcset = primaryImage.srcset;
					wrapper.dataset.originalWidth = primaryImage.width;
					wrapper.dataset.originalHeight = primaryImage.height;
					
					const defaultInput = wrapper.querySelector(".js-color-swatches input[checked]");
					if (defaultInput) {
						wrapper.dataset.originalColor = defaultInput.value;
					} else {
						// fallback to currently clicked if no checked attribute is found initially (edge case)
						wrapper.dataset.originalColor = event.currentTarget.value;
					}
				}

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelectorAll(".js-color-swatches-link")
						.forEach((item) =>
							item.setAttribute("href", event.currentTarget.dataset.variantLink)
						);
					const currentColor = event.currentTarget.value;
					const currentStyle = primaryImage.style.cssText;

					const replaceImage = (newPrimaryImage) => {
						if (newPrimaryImage.src !== primaryImage.src) {
							let flag = false;
							if (secondaryImage) {
								const secondaryImagePathname = new URL(secondaryImage.src).pathname;
								const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

								if (secondaryImagePathname == newPrimaryImagePathname) {
									primaryImage.remove();
									secondaryImage.classList.remove("media--second");
									secondaryImage.classList.add("media--first");
									flag = true;
								}
							}
							if (flag == false) {
								primaryImage.animate(
									{ opacity: [1, 0] },
									{ duration: 200, easing: "ease-in", fill: "forwards" }
								).finished;
								setTimeout(function () {
									primaryImage.replaceWith(newPrimaryImage);
									newPrimaryImage.animate(
										{ opacity: [0, 1] },
										{ duration: 200, easing: "ease-in" }
									);
									if (secondaryImage) {
										secondaryImage.remove();
									}
								}, 200);
							}
						}
					};

					if (currentColor === wrapper.dataset.originalColor && wrapper.dataset.originalSrc) {
						const newPrimaryImage = new Image(wrapper.dataset.originalWidth, wrapper.dataset.originalHeight);
						newPrimaryImage.className = primaryImage.className;
						newPrimaryImage.alt = primaryImage.alt || "";
						newPrimaryImage.sizes = primaryImage.sizes;
						newPrimaryImage.src = wrapper.dataset.originalSrc;
						newPrimaryImage.srcset = wrapper.dataset.originalSrcset;
						newPrimaryImage.loading = "lazy";
						if (currentStyle) newPrimaryImage.style.cssText = currentStyle;
						replaceImage(newPrimaryImage);
					} else {
						jQuery.getJSON(
							window.Shopify.routes.root + `products/${handleProduct}.js`,
							function (product) {
								const variant = product.variants.filter(
									(item) =>
										item.featured_media != null &&
										item.options.includes(currentColor)
								)[0];
								if (variant) {
									const newPrimaryImage = createImageElement(
										variant["featured_media"],
										primaryImage.className,
										primaryImage.sizes,
										product.title,
										currentStyle
									);
									replaceImage(newPrimaryImage);
								}
							}
						);
					}
				}
			});
		});
	});
};

function colorSwatches() {
	checkSwatches();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
	});
}

(function () {
	colorSwatches();
})();
